// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Box__wrapper___1RWIo","isCentered":"Box__isCentered___mDR5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Box/Box.scss
// module id = 649
// module chunks = 0